import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { ScrollToTop } from "../components/ScrollToTop";
import { Hero } from "../components/Hero";
import { NovaShowcase } from "../components/NovaShowcase";
import { Services } from "../components/Services";
import { WhyInceptica } from "../components/WhyInceptica";
import { Leadership } from "../components/Leadership";
import { About } from "../components/About";
import { Contact } from "../components/Contact";

export default function HomePage() {
  return (
    <div className="relative min-h-screen bg-white" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <NovaShowcase />
        <Services />
        <WhyInceptica />
        <About />
        <Leadership />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
